// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__U37uQ","colBig":"styles_colBig__2qyrJ","colSmall":"styles_colSmall__3CJ5C"};